import React from 'react';

import Modal from './../../../components/UI/Modal/Modal';
import Zigzag from './../Common/Shapes/Zigzag';

const MessageModal = (props) => 
{
    const classes = 'message' + (typeof props.class !== 'undefined'?' '+props.class:'' )+ (Array.isArray(props.message)?' multiple-message-'+(props.message.length-1):'') + ( typeof props.button !== 'undefined'?' with-button':'');

    return (
    <Modal show={props.show} modalClosed={props.closeModalHandler} class={classes}>
        {typeof props.zigzagColor !== 'undefined' && 
            <div className={props.zigzagClass}>    
                <Zigzag color={props.zigzagColor} />
            </div>}
        <div className='modal-container'>
            <div className="close-button" onClick={props.closeModalHandler}></div>
            {typeof props.image !== 'undefined' && <div className={`image ${props.image}`}> </div>}
            {typeof props.title !== 'undefined' && <div className="title">{props.title}</div>}
            {typeof props.title !== 'undefined' && <div className="text">{props.message}</div>}
            {typeof props.title === 'undefined' && (Array.isArray(props.message)?props.message.map(msg => (<div className={`multiple-text ${msg[0]}`} key={'error-msg-'+msg[0]}>{msg[1]}</div>)):<div className="text-no-title">{props.message}</div>)}
        </div>
        {typeof props.button !== 'undefined' && <div className={`popup-button ${typeof props.buttonClass !== 'undefined'?props.buttonClass:''}`} onClick={typeof props.buttonHandler !== 'undefined'?props.buttonHandler:props.closeModalHandler }>{props.button}</div>}
    </Modal>
);
}


export default MessageModal;


// WEBPACK FOOTER //
// ./src/containers/UI/MessageModal/MessageModal.js